// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
// @components
const WarningMessage = require('components/contactCenter/warningMessage/warningMessage');
//@core
const { formatText } = require('core/i18n').i18n;
// @ actions
const { requestAccountWarningMessage } = require('actions/contactCenter/accountWarningMessage/accountWarningMessage');

class AccountWarningMessage extends React.Component {

    componentDidMount() {
        const { requestAccountWarningMessage, immAccount } = this.props;
        const digitoControl = immAccount.getIn(['ibanComplex', 'digitodecontrol']);
        const numeroCuenta = immAccount.getIn(['ibanComplex', 'codbban']).slice(-10);
        const producto = immAccount.get('product');
        const numeroContrato = immAccount.get('contractNumber');
        requestAccountWarningMessage(digitoControl, numeroCuenta, producto, numeroContrato);
    }

    render() {

        const { immAccount, immAccountWarningMessage } = this.props;
        const text = formatText('accountDetails-accountHasWarning');
        const visible = immAccountWarningMessage.getIn(['data', 'accountHasWarning']);
        const accountId = immAccount.get('accountId');
        const linkTo = `/myprofile/accounts/${accountId}/warnings`;

        return (
            <WarningMessage
                text={text}
                visible={visible}
                isLink={true}
                to={linkTo}
            />
        );
    }
}

AccountWarningMessage.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immAccountWarningMessage: PropTypes.object.isRequired,
    requestAccountWarningMessage: PropTypes.object.isRequired,
};

module.exports.constructor = AccountWarningMessage;
module.exports.AccountWarningMessage = connect(
    state => ({
        immAccountWarningMessage: state.accountWarningMessage,
    }),
    {
        requestAccountWarningMessage,
    }
)(AccountWarningMessage);
